import { Check } from 'lucide-react';

import { Container } from '../components/Container';
import { SectionHeading } from '../components/SectionHeading';
import type { LandingContent } from '../content/types';
import { sectionIds } from '../lib/routes';

type PackagesSectionProps = {
  content: LandingContent;
};

export function PackagesSection({ content }: PackagesSectionProps) {
  return (
    <section className="section section--muted" id={sectionIds.solutions} aria-labelledby="packages-title">
      <Container>
        <SectionHeading id="packages-title" title={content.packages.h2} align="center" />
        <div className="card-grid card-grid--packages">
          {content.packages.items.map((item) => (
            <article className="package-card" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.audience}</p>
              <h4>{content.common.includes}</h4>
              <ul>
                {item.includes.map((include) => (
                  <li key={include}>
                    <Check aria-hidden="true" size={16} />
                    <span>{include}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
